import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * @graph-node {Page}
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business プロジェクト管理レイアウトルート。配下の /projects (index) と /projects/pmo-board をOutletで描画する薄いラッパー
 * @graph-connects none
 */
export const Route = createFileRoute('/projects')({
  component: ProjectsLayout,
});

/** @graph-connects none */
function ProjectsLayout() {
  return <Outlet />;
}
